import React, { useState } from "react";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { ReorderModal } from "../../../../../boxes/ReorderModal/ReorderModal";
import { Select } from "../../../../../shared/Select/Select";
import { useCategories } from "./hooks/useCategories";
import { useServices } from "./hooks/useServices";
import { useSelectedCategory } from "./hooks/useSelectedCategory";
import { useSaveOrder } from "./hooks/useSaveOrder";

export function ObOrder() {
  const { tCommon } = useAppTranslation.Common();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { categoriesList, isCategoriesLoading } = useCategories();

  const { selectedCategory, selectCategory } =
    useSelectedCategory(categoriesList);

  const { services, isServicesLoading } = useServices(selectedCategory?.value);
  const { save, isSaving } = useSaveOrder();

  const submit = (orderedServices) => {
    save({
      selectedCategory,
      orderedServices,
    });
  };

  return (
    <>
      <button
        className="easy-link no-padding"
        onClick={() => setIsModalOpen(true)}
      >
        {tCommon("label.obOrder")}
      </button>
      {isModalOpen && (
        <ReorderModal
          isLoading={isCategoriesLoading || isServicesLoading}
          isSaving={isSaving}
          isOpen={isModalOpen}
          data={services}
          onClose={() => setIsModalOpen(false)}
          title={tCommon("label.obOrder")}
          onSave={submit}
          renderSubheader={({ isTouched }) => (
            <Select
              isDisabled={isSaving}
              options={categoriesList}
              value={selectedCategory}
              onChange={(next) => selectCategory({ next, isTouched })}
            />
          )}
        />
      )}
    </>
  );
}
